var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire app"}},[_c('Menu',{attrs:{"id":"topH"}}),_c('router-view',{attrs:{"id":"view"}}),_c('icon-chatbot',{attrs:{"initOpenProp":false}}),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }